module.exports = __webpack_public_path__ + "img/inform1.deff947.78ef5713.png";